// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2p1Jv","footer":"ModalUpdate_footer__1C7mp"};